import vBanner from "./v-banner.vue";

export default Vue => {
  Vue.component("v-banner", vBanner);
};
